const themeLightStateDisabled = '#949598';

export { themeLightStateDisabled };
